import React, { useState } from 'react';
import { Card, Divider, FormControl, InputBase, Button, withStyles} from '@material-ui/core';
import {styles} from '../../component/game/user_interface/assets/frontPageUI'
import {withApollo} from 'react-apollo'
import {DUPLICATE_GAME} from '../../api/graphql-mutation'
import { getUserId } from '../../utility/function';

const BranchModal = ({
  client,
  classes,
  selectedBranch,
  branchSuggest,
  setBranchSuggest,
  history,
  onCreateJamExternal, // optional external create handler
}) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') setName(value);
    else if (name === 'password') setPassword(value);
  };

  const handleCreateJam = () => {
    // setLoading(true);
    
    if (name === ''){
        alert('Please Fill All Information!');
        return;
    }

    createBranch()

  };


  const  createBranch = () => {
          
    let branchSuggest = false
    let setup = {
        createdBy: getUserId(),
        name,
        password: passwordChecker(),
    }

    let automationChange = null
    // if(branchSuggest){
    //     let link = this.linkSegment(selectedBranch.data.general.suggestedTemplate)
    //     let jb = this.state.publicJambuilders.find((pjb)=>{return pjb._id === link})

    //     automationChange = jb.general.gameLink
    // }

    // console.log(automationChange)

    console.log(selectedBranch,name,password)

    client.mutate({
        mutation: DUPLICATE_GAME,
        variables: {
            _id: selectedBranch,
            setup,
            automationChange,
        }
    }).then((status)=>{
        // console.log(status)
        // this.setState({name:"",password:"", type: ""});
        // this.jbIndex = null
        window.location.href=`/game/${status.data.gameDuplicate._id}`
        //window.location.reload(); // temporary for jambuilder setup
    })
}

  const passwordChecker = () => {
        if(password === ""){
            return null
        }else{
            return password
        }
  }

  const linkSegment = (link) => {
    // console.log(link)
    let url = new URL(link)
    let segments = url.pathname.split('/')
    return segments[segments.length-1]
  }

  if (!selectedBranch) return null;

  return (
    <Card style={{margin:"auto", marginTop:"15%"}} className={classes.popUp}>
      <div style={{ textAlign: "center", whiteSpace: "break-spaces" }} className={classes.popUpHeader}>
        Branch a Jam{"\n"}<span>{selectedBranch.name}</span>
      </div>
      <Divider />
      <div className={classes.popUpContent}>
        <FormControl style={{ width: "100%", fontSize: "0.875rem", color: "#4F4F4F" }}>
          <b>Jam Name *</b>
          <p style={{ color: "#828282", fontSize: "0.7rem", marginBottom: "5px" }}>
            Give your jam a unique name!
          </p>
          <InputBase
            className={classes.field}
            placeholder="Example: Wayne's World"
            name="name"
            value={name}
            onChange={handleChange}
            inputProps={{
              style: { fontSize: "0.875rem", fontFamily: "arial" },
              maxLength: 17,
            }}
          />

          <div style={{ fontSize: "0.875rem", color: "#4F4F4F" }}>
            <b>Jam Password</b>
            <i style={{ marginLeft: "0.2em", color: "#B8B8B8" }}>(Optional)</i>
            <p style={{ color: "#828282", fontSize: "0.7rem", marginBottom: "5px" }}>
              Only those with your jam’s password may view your waiting room. If none is set, anyone can view your waiting room!
            </p>
          </div>
          <InputBase
            className={classes.field}
            type="password"
            placeholder="password"
            name="password"
            value={password}
            onChange={handleChange}
            inputProps={{
              style: { fontSize: "0.875rem", fontFamily: "arial" },
            }}
          />

          <div style={{ fontSize: "0.875rem", color: "#4F4F4F" }}>
            <b>Jam Template</b>
            <p style={{ color: "#828282", fontSize: "0.7rem", marginBottom: "5px" }}>
              Use back the same template as the original jam or starts fresh as a freestyle jam!
            </p>

            {branchSuggest && (
              <div style={{ paddingTop: "1em", fontSize: "14px" }}>
                <button
                  disabled
                  onClick={() => console.log("suggestion")}
                  style={{
                    width: "100%",
                    marginRight: "1em",
                    padding: "1em",
                    borderRadius: "5px",
                    background: branchSuggest ? "#00dfff" : "#fff3b4",
                  }}
                >
                  <span style={{ fontWeight: "bold", fontSize: "16px" }}>Suggested</span><br />
                  <span>{linkSegment(branchSuggest)}</span>
                </button>
              </div>
            )}

            <div style={{ padding: "1em 0", fontSize: "14px" }}>
              <button style={{ width: "155px", marginRight: "1em", padding: "1em", borderRadius: "5px", background: "white" }}>
                Reuse Template
              </button>
              <button style={{ width: "155px", padding: "1em", borderRadius: "5px", background: "white" }}>
                Freestyle
              </button>
            </div>
          </div>

          <Button
            onClick={handleCreateJam}
            disabled={name === '' || loading}
            className={name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
          >
            Go to waiting room
          </Button>
        </FormControl>
      </div>
    </Card>
  );
};

export default withApollo((withStyles(styles)(BranchModal)));
